var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9248 11.232H12.7183C12.7183 11.232 16.6266 15.0091 17.5817 16.0487C18.5367 17.0884 17.1827 18.2852 16.2277 17.4994C15.2727 16.7136 11.2305 12.7197 11.2305 12.7197V11.9262L10.933 11.6287C9.84195 12.6206 8.3542 13.2157 6.76726 13.2157C3.19664 13.2157 0.320312 10.3393 0.320312 6.76872C0.320312 3.19811 3.19664 0.321777 6.76726 0.321777C10.3379 0.321777 13.2142 3.19811 13.2142 6.76872C13.2142 8.35566 12.6191 9.84342 11.6273 10.9344L11.9248 11.232ZM6.75679 11.9936C9.64817 11.9936 11.9921 9.64963 11.9921 6.75826C11.9921 3.86688 9.64817 1.52295 6.75679 1.52295C3.86541 1.52295 1.52148 3.86688 1.52148 6.75826C1.52148 9.64963 3.86541 11.9936 6.75679 11.9936Z",
    fill: "#B3B3B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.be4e1503.svg";
export { ForwardRef as ReactComponent };